const OOPS_IMAGE = require('@/assets/characters/oops.svg')
const ALERTA_IMAGE = require('@/assets/characters/alerta.svg')

const BASE_SWAL_OPTIONS = {
  imageWidth: 150,
  confirmButtonText: 'Entendido',
  icon: false,
  allowEscapeKey: false,
  allowOutsideClick: false
}

function showPrestamosVidaAlert (vm, { title, text, imageUrl }) {
  return vm.$swal({
    ...BASE_SWAL_OPTIONS,
    title,
    text,
    imageUrl
  })
}

export function showPrestamosVidaErrorAlert (vm, text, title = '¡Lo sentimos!') {
  return showPrestamosVidaAlert(vm, {
    title,
    text,
    imageUrl: OOPS_IMAGE
  })
}

export function showPrestamosVidaAtencionAlert (vm, text, title = 'Atención') {
  return showPrestamosVidaAlert(vm, {
    title,
    text,
    imageUrl: ALERTA_IMAGE
  })
}



// WEBPACK FOOTER //
// ./src/utils/prestamosVidaAlertUtil.js